// extracted by mini-css-extract-plugin
export var chatHtmlText = "_r5-2";
export var chatLink = "_r5-0";
export var chatText = "_r5-1";